import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hpsfir-card grade" }

import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();
const storeOptions = ref<{ label: string; value: number }[]>([]);

const addInitValue = {

};

const conditionsInitValue = {
};

// 创建列定义
const createColumns = () => [
  {
    name: 'name',
    label: '年级名称',
    type: 'string',
    isCondition: true,
    rule: [{ required: true, message: '请输入年级名称' }],
    width: 150,
  },
  {
    name: 'educationStageId',
    label: '教育阶段',
    type: 'select',
    isCondition: true,
    rule: [{ required: true, message: '请选择教育阶段' }],
    options: storeOptions,
    width: 150,
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 160,
  },
] as HpsfirProTableColumn[];

// 初始化
const init = useBaseAsync(async() => {
  // 获取教育阶段列表
  const educationStageRes = await useApi().educationstageApi.listEducationStageeducationstage({
    conditions: {},
  });

  storeOptions.value = (educationStageRes.data.data || []).map((item: any) => ({
    label: item.name,
    value: item.id,
  }));

  columns.value = createColumns();
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().gradeApi.pageGradegrade({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;

        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除"${row.name || '未命名'}"年级吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().gradeApi.addGradegrade({
    gradeAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().gradeApi.updateGradegrade({
    gradeAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().gradeApi.delGradegrade(data.id);
  ElMessage.success('删除成功');
});

Promise.all([init()]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(HpsfirProTable), {
      ref_key: "tableRef",
      ref: tableRef,
      title: "年级管理",
      paginations: { pageSize: 10 },
      "page-layout": "total, sizes, prev, pager, next",
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(addFun),
      "on-delete": _unref(deleteFun),
      "on-edit": _unref(updateFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      operates: operates,
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading"])
  ]))
}
}

})